import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="bg-secondary py-10 md:py-14 px-4 md:px-12 border-y border-card" data-id="element-93">
      <div className="max-w-2xl mx-auto text-center" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-95">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warm-white mb-6" data-id="element-96">
            Pruébalo sin presión.
          </h2>

          <p className="font-inter text-lg md:text-xl text-warm-muted leading-relaxed mb-4" data-id="element-97">
            Si no sientes ningún cambio…{' '}
            <span className="text-warm-white font-semibold" data-id="element-98">
              te devolvemos el dinero
            </span>
            .
          </p>

          <p className="font-inter text-base md:text-lg text-warm-muted mb-4" data-id="element-99">
            Tienes 30 días completos para probarlo.
          </p>

          <p className="font-playfair italic text-xl md:text-2xl text-gold" data-id="element-100">
            Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}